// const adminSections = {
//     main: { key: 'main', name: 'Main Options', },
//     website: { key: 'website', name: 'Website Options', },
//     extra: { key: 'extra', name: 'Extra Options', },
//     admin: { key: 'admin', name: 'Admin Options', },
//     // settings: { key: 'settings', name: 'Settings Options', },

import { adminPages } from "./adminPages"

// }

const adminWidgets = {

 


    // "newForumQuesions": {
    //     key: 'TableWidget',
    //     page: 'users',

    //     col: '12',
    //     title: 'سوالات جدید فروم',
    //     headers: adminPages.questions.headers,
    //     pages: adminPages.questions.pages,
    //     // permissionParent: 'permissions',
    //     permissionParent: 'admin.rental',


    //     fetchUrl: 'getQuestions',
    //     addUrl: 'postQuestion',
    //     editUrl: 'postQuestion',
    //     removeUrl: 'removeQuestion',
    //     // populate: ["category"],

    //     postBody: { "values.status": '0', archived: { $ne: true } },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },



    // "partnershipReq": {
    //     key: 'TableWidget',
    //     page: 'partnershipReq',

    //     col: '12',
    //     title: 'درخواست نمایندگی فروش',
    //     headers: adminPages.partnershipReq.headers,
    //     permissionParent: 'admin.partnershipReq',

    //     fetchUrl: 'getContents',
    //     removeUrl: 'removeContent',
    //     postBody: {  },
    //     populate: [],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },
    // "partnershipRepairReq": {
    //     key: 'TableWidget',
    //     page: 'partnershipRepairReq',

    //     col: '12',
    //     title: 'درخواست نمایندگی پس از فروش',
    //     headers: adminPages.partnershipRepairReq.headers,
    //     permissionParent: 'admin.partnershipRepairReq',

    //     fetchUrl: 'getContents',
    //     removeUrl: 'removeContent',
    //     postBody: {  },
    //     populate: [],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },
    // "fallowRepairReq": {
    //     key: 'TableWidget',
    //     page: 'fallowRepairReq',

    //     col: '12',
    //     title: 'درخواست پیگیری تعمیرات   ',
    //     headers: adminPages.fallowRepairReq.headers,
    //     permissionParent: 'admin.fallowRepairReq',

    //     fetchUrl: 'getContents',
    //     removeUrl: 'removeContent',
    //     postBody: {  },
    //     populate: [],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },
    // "imeiRequest": {
    //     key: 'TableWidget',
    //     page: 'imeiRequest',

    //     col: '12',
    //     title: ' درخواست imei ',
    //     headers: adminPages.imeiRequest.headers,
    //     permissionParent: 'admin.imeiRequest',

    //     fetchUrl: 'getContents',
    //     removeUrl: 'removeContent',
    //     postBody: {  },
    //     populate: [],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },
    // "complains": {
    //     key: 'TableWidget',
    //     page: 'complains',

    //     col: '12',
    //     title: 'شکایات   ',
    //     headers: adminPages.complains.headers,
    //     permissionParent: 'admin.complains',

    //     fetchUrl: 'getContents',
    //     removeUrl: 'removeContent',
    //     postBody: {  },
    //     populate: [],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },
    // "survey": {
    //     key: 'TableWidget',
    //     page: 'survey',

    //     col: '12',
    //     title: 'نظر سنجی   ',
    //     headers: adminPages.survey.headers,
    //     permissionParent: 'admin.survey',

    //     fetchUrl: 'getContents',
    //     removeUrl: 'removeContent',
    //     postBody: {  },
    //     populate: [],
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },
    // },




    // "pendingPartners": {
    //     key: 'TableWidget',
    //     page: 'questions',

    //     col: '12',
    //     title: 'Pending Partners',
    //     headers: adminPages.questions.headers,
    //     permissionParent: 'admin.questions',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     postBody: { "values.status": 1 },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "pendingPartners2": {
    //     key: 'TableWidget',
    //     page: 'answers',

    //     col: '12',
    //     title: 'Pending Partners',
    //     headers: adminPages.answers.headers,
    //     permissionParent: 'admin.answers',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     postBody: { "values.status": 1 },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "pendingPartners2": {
    //     key: 'TableWidget',
    //     page: 'contents',

    //     col: '12',
    //     title: 'Pending Partners',
    //     headers: adminPages.contents.headers,
    //     permissionParent: 'admin.contents',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     fetchUrl: 'getUsers',
    //     addFetch: 'addUser',
    //     removeUrl: 'removeUser',
    //     postBody: { "values.status": 1 },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },



    //     "pendingPartners2": {
    //         key: 'TableWidget',
    //         page: 'categories',

    //         col: '12',
    //         title: 'Pending Partners',
    //         headers: adminPages.categories.headers,
    //         permissionParent: 'admin.categories',
    //         addUrl: 'addValue',
    //         editUrl: 'addValue',
    //         fetchUrl: 'getUsers',
    //         addFetch: 'addUser',
    //         removeUrl: 'removeUser',
    //         postBody: { "values.status": 1 },
    //         actions: {
    //             edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //         },

    //     },

    // }
    // "pendingEnquiries": {
    //     key: 'TableWidget',
    //     page: 'contact',

    //     col: '12',
    //     title: 'Pending Enquiries',
    //     headers: adminPages.contact.headers,
    //     permissionParent: 'admin.contact',

    //     fetchUrl: 'getAll',
    //     addUrl: 'addValue',
    //     editUrl: 'addValue',
    //     removeUrl: 'removeValue',
    //     postBody: { "values.status": '0' },
    //     actions: {
    //         edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData", permission: 'view' },
    //     },

    // },


    // "usersActivity": {
    //     key: 'TableWidget',
    //     page: 'logs',

    //     col: '12',
    //     title: 'Users activities',
    //     headers: adminPages.logs.headers,
    //     permissionParent: 'admin.logs',

    //     fetchUrl: 'getInbox',
    //     addUrl: 'addInbox',
    //     editUrl: 'addInbox',
    //     removeUrl: 'removeInbox',
    //     // postBody: { "values.status": 1 },
    //     actions: {
    //         // edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditModal", ref: "invoices", loader: "isPostingData" },
    //     },

    // }





}


export { adminWidgets }